import React from "react";
import IconButton from "@material-ui/core/IconButton";
import Snackbar from "@material-ui/core/Snackbar";
import SnackbarContent from "@material-ui/core/SnackbarContent";
import { makeStyles } from "@material-ui/core/styles";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import CloseIcon from "@material-ui/icons/Close";
import ErrorIcon from "@material-ui/icons/Error";
import InfoIcon from "@material-ui/icons/Info";
import WarningIcon from "@material-ui/icons/Warning";

const variantIcons = {
  success: CheckCircleIcon,
  warning: WarningIcon,
  error: ErrorIcon,
  info: InfoIcon,
};

const variantPositions = {
    topLeft: {
        vertical: "top",
        horizontal: "left",
    },
    topRight: {
        vertical: "top",
        horizontal: "right",
    },
    bottomLeft: {
        vertical: "bottom",
        horizontal: "left",
    },
    bottomRight: {
        vertical: "bottom",
        horizontal: "right",
    }
}

const variantColors = {
    red: '#eb2914',
    blue: '#03B8FF',
    yellow: '#ffdd03'
}

const useStyles = makeStyles(theme => ({
  container: {
      maxWidth: '90vw',
    background: "0% 0% no-repeat padding-box",
  },
  icon: {
    fontSize: 20,
  },
  iconVariant: {
    opacity: 0.9,
    paddingRight: 5,
  },
  message: {
      fontWeight: 'bold',
      fontSize: '1rem',
    display: "flex",
    alignItems: "center",
  },
}));

function MySnackbarContentWrapper(props) {
  const classes = useStyles();
  const { message, requestClose, variantIcon, variantColor } = props;
  const Icon = variantIcon;

  return (
    <SnackbarContent
      classes={{ root: classes.container }}
      style={{backgroundColor: variantColor || '#03B8FF'}}
      aria-describedby="notifier"
      message={
        <span className={classes.message}>
          <Icon className={classes.iconVariant} />
          {message}
        </span>
      }
      action={[
        <IconButton
          key="close"
          aria-label="close"
          color="inherit"
          onClick={requestClose}
        >
          <CloseIcon className={classes.closeIcon} />
        </IconButton>,
      ]}
    />
  );
}

function Notifier(props) {
  return (
    <div>
      <Snackbar
        anchorOrigin={props.variantPosition || variantPositions.bottomLeft}
        onClose={props.requestClose}
        open={props.open}
        autoHideDuration={120000}
      >
        <MySnackbarContentWrapper
          message={props.message}
          requestClose={props.requestClose}
          variantIcon={props.variantIcon}
          variantColor={props.variantColor || variantColors.blue}
        />
      </Snackbar>
    </div>
  );
}
export default Notifier;
export const notifierVariants = {variantPositions, variantIcons, variantColors};
